const getAdminOriginsByRecorderOrigins = (): Record<string, string> =>
  JSON.parse(process.env.VUE_APP_ADMIN_HOSTS ?? '{}');

const toAdminOrigin = (recorderHost: string): string => {
  const adminHosts = getAdminOriginsByRecorderOrigins();
  return adminHosts[recorderHost] ?? Object.values(adminHosts)[0] ?? '';
};

const adminOriginAvailableForRecorderOrigin = (recorderHost: string): boolean =>
  !!getAdminOriginsByRecorderOrigins()[recorderHost];

const getPrioritizedAdminOrigins = (): string[] =>
  adminOriginAvailableForRecorderOrigin(location.origin)
    ? [
        getAdminOriginsByRecorderOrigins()[location.origin],
        ...Object.values(getAdminOriginsByRecorderOrigins()).filter((host) => host !== toAdminOrigin(location.origin)),
      ]
    : Object.values(getAdminOriginsByRecorderOrigins());

export {
  getAdminOriginsByRecorderOrigins,
  getPrioritizedAdminOrigins,
  toAdminOrigin,
  adminOriginAvailableForRecorderOrigin,
};
